module.exports = __webpack_public_path__ + "img/card9.85fefbab.png";